import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import api from "@/lib/api";
import { Loader2 } from "lucide-react";

export const ProofViewer = ({ row, onClose }) => {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!row?.proof_path) return;
    let blobUrl;
    api
      .get(`/registrations/${row.id}/proof`, { responseType: "blob" })
      .then((res) => {
        blobUrl = URL.createObjectURL(res.data);
        setUrl(blobUrl);
      })
      .catch(() => setError(true));
    return () => blobUrl && URL.revokeObjectURL(blobUrl);
  }, [row]);

  return (
    <Dialog open={!!row} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg bg-[#121216] border-amber-500/25 text-zinc-100" data-testid="proof-viewer-dialog">
        <DialogHeader>
          <DialogTitle className="font-display gold-text text-xl">Payment Proof</DialogTitle>
          <DialogDescription className="text-sm text-zinc-400">
            {row?.full_name} · Transaction ID:{" "}
            <span className="font-mono-lux text-amber-100" data-testid="proof-viewer-txn">
              {row?.transaction_id || "—"}
            </span>
          </DialogDescription>
        </DialogHeader>
        {row?.proof_path ? (
          <div className="rounded-xl overflow-hidden gold-border bg-black min-h-[200px] flex items-center justify-center">
            {error ? (
              <p className="text-sm text-red-400 p-6">Could not load screenshot.</p>
            ) : url ? (
              <img src={url} alt="Payment screenshot" className="max-h-[60vh] w-auto" data-testid="proof-viewer-image" />
            ) : (
              <Loader2 className="w-6 h-6 text-amber-400 animate-spin" />
            )}
          </div>
        ) : (
          <p className="text-sm text-zinc-500" data-testid="proof-viewer-no-image">No screenshot uploaded.</p>
        )}
      </DialogContent>
    </Dialog>
  );
};
